import CalendarInlineComposeViewState from './store/schema/CalendarInlineComposeViewState';
import CalendarRollUpViewState from './store/schema/CalendarRollUpViewState';
import ConversationReadingPaneViewState from './store/schema/ConversationReadingPaneViewState';
import ItemPartViewState from './store/schema/ItemPartViewState';
import QuotedBodyViewState from './store/schema/QuotedBodyViewState';
import { getFocusedItemPart } from './utils/focusedItemPartUtils';
import { getItemsCountInCollapsedItemsRollUp } from './utils/rollUp/collapsedItemsRollUpUtils';
import { ClientItemId } from 'owa-client-ids';
import { ActionSource } from 'owa-analytics-actions';

export default {
    // Performance data of load conversation reading pane
    RPPerfLoadConversationReadingPane: { name: 'RPPerfLoadConversationReadingPane' },

    // Performance data of load item reading pane
    RPPerfLoadItemReadingPane: {
        name: 'RPPerfLoadItemReadingPane',
    },

    // Counts the number of times users collapse the quoted text
    // CustomData: 1 - isQuotedTextChanged
    //             2 - isExpanded
    RPCountExpCollQuotedText: {
        name: 'RPCountExpCollQuotedText',
        customData: (
            viewState: QuotedBodyViewState,
            itemId: string,
            isQuotedTextChanged: boolean
        ) => {
            return [!!isQuotedTextChanged ? 1 : 0, !viewState.isExpanded];
        },
    },

    // Count the number of times user expand/collapse item part
    // CustomData: 1 - itemPartStateChange:
    //                      "SC" - select to collapse,
    //                      "ES" - expand to select,
    //                      "CS" - collapse to select
    //                      "EC" - expand to collapse
    //                      "CE" - collapse to expand
    // CustomData: 2 - fromKeyboard
    RPCountExpCollItemPart: {
        name: 'RPCountExpCollItemPart',
        customData: (itemPart: ItemPartViewState, fromKeyboard: boolean, canFocus: boolean) => {
            let state: string;
            if (fromKeyboard || canFocus) {
                if (itemPart.isExpanded) {
                    state = 'EC';
                } else {
                    state = 'CE';
                }
            } else {
                if (itemPart == getFocusedItemPart()) {
                    state = 'SC';
                } else if (itemPart.isExpanded) {
                    state = 'ES';
                } else {
                    state = 'CS';
                }
            }

            return [state, fromKeyboard];
        },
    },

    // Counts the number of user click to load more
    RPCountLoadMore: { name: 'RPCountLoadMore' },

    RPCountExpCollItemsRollUp: {
        name: 'RPCountExpCollItemsRollUp',
        customData: (viewState: ConversationReadingPaneViewState, isAuto: boolean) => {
            return [getCountBucket(getItemsCountInCollapsedItemsRollUp(viewState)), isAuto];
        },
    },

    RPCountExpCollAllItemParts: {
        name: 'RPCountExpCollAllItemParts',
        customData: (shouldExpand: boolean, isFromShortcut: boolean) => [
            shouldExpand,
            isFromShortcut,
        ],
    },

    PrintItem: {
        name: 'PrintItem',
        actionSource: (itemId: ClientItemId, actionSource: ActionSource) => actionSource,
    },

    ReplyByMeeting: {
        name: 'ReplyByMeeting',
        actionSource: (
            referenceItemId: string,
            calendarInlineComposeViewState?: CalendarInlineComposeViewState,
            shouldSend?: boolean,
            actionSource?: ActionSource
        ) => actionSource,
    },

    ToggleIsCalendarRollUpExpanded: {
        name: (viewState: CalendarRollUpViewState) => {
            return viewState.isExpanded ? 'RPCollapseCalendarRollUp' : 'RPExpandCalendarRollUp';
        },
    },

    ToggleCalendarRollUpItemPartExpanded: {
        name: (viewState: ItemPartViewState) => {
            return viewState.isExpanded
                ? 'RPCollapseCalendarRollUpItemPart'
                : 'RPExpandCalendarRollUpItemPart';
        },
    },
};

export function getCountBucket(count: number): number {
    return Math.min(Math.floor(count / 2), 24);
}
